import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { editEmployee, getByEmployeeId, getRole, getstatus } from "./EmployeeServices";
import { emailRegex, floatingRegex, phoneRegex } from "../../components/common/Helpers/Validations";
import * as yup from "yup";

export const formFields: any = [
    {
        label: "First Name",
        type: 'text',
        name: 'f_name',
        placeholder: 'Enter First Name'
    },
    {
        label: "Last Name",
        type: 'text',
        name: 'l_name',
        placeholder: 'Enter Last Name'
    },
    {
        label: "Email",
        type: 'text',
        name: 'email',
        placeholder: 'Enter Email'
    },
    {
        label: "Mobile Number",
        type: 'text',
        name: 'mobile_number',
        placeholder: 'Enter Mobile Number'
    },

    {
        label: "City",
        type: 'text',
        name: 'city',
        placeholder: 'Enter City'
    },
    {
        label: "State",
        type: 'text',
        name: 'state',
        placeholder: 'Enter State'
    },
    {
        label: "Experience",
        type: 'number',
        name: 'experience',
        placeholder: 'Enter Experience'
    },
    {
        label: "Previous Company",
        type: 'text',
        name: 'previous_company',
        placeholder: 'Enter Previous Company'
    },
    {
        label: "Job Role",
        type: 'text',
        name: 'job_role',
        placeholder: 'Enter Job Role'
    },
    {
        label: "Resume Upload",
        type: 'file',
        name: 'resume_upload',
        placeholder: 'Enter Resume Upload'
    },
    {
        label: "Skills",
        type: 'text',
        name: 'skills',
        placeholder: 'Enter Skills'
    },

]

export const validationSchema = yup.object({
    f_name: yup.string().ensure().required("First Name is required!").min(3, 'To short!'),
    l_name: yup.string().ensure().required("Last Name is required!").min(3, 'To short!'),
    email: yup.string().ensure().required("Email is required!").min(3, 'To short!').matches(emailRegex,{message:'Enter Valid Email'}),
    mobile_number: yup.string().ensure().required(" Mobile Number is required!").min(10, 'Invalid Mobile Number').max(10, 'Invalid Mobile Number').matches(phoneRegex,{message:'Enter Valid Mobile Number',}),
    city: yup.string().ensure().required("City is required!").min(3, 'To short!'),
    state: yup.string().ensure().required("State is required!").min(3, 'To short!'),
    experience: yup.string().ensure().required("Experience is required!").matches(floatingRegex,{message:'Please enter only Numbers!',}),
    previous_company: yup.string().ensure().required("Previous Company is required!").min(3, 'To short!'),
    job_role: yup.string().ensure().required("Job Role is required!").min(3, 'To short!'),
    resume_upload: yup.string().ensure().required("Resume Upload is required!").min(3, 'To short!'),
    skills: yup.string().ensure().required("Skills is required!").min(3, 'To short!'),
});

export const EmployeeEdit = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Edit Job Seaker" />
                                <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={editEmployee}
                                    listPageKey='EMPLOYEE_LIST'
                                    type="edit"
                                    detailService={getByEmployeeId}
                                />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
